import * as React from "react";

import Container from "@material-ui/core/Container";

import { Switch, Route, Redirect } from "react-router-dom";

import { AppMenu } from "../../controllers/app-menu";
import { AppHeader } from "../../controllers/app-header";

import { ReleasesListPage } from "../releases-list";
import { routes } from "../../routes";
import { ArtistListPage } from "../artist-list";
import { ArtistDetailPage } from "../artist-detail";
import { ArtistEarningsPage } from "../artist-earnings";
import { EarningsListPage } from "../earnings-list";
import { EarningsDetailPage } from "../earnings-detail";
import { EarningsSummaryPage } from "../earnings-summary";
import { UsersListPage } from "../users-list";
import { UserDetailPage } from "../user-detail";
import { ReleaseDetailPage } from "../release-detail";
import { UserInboxPage } from "../user-inbox";
import { BackofficeUserTier } from "../../../../../services/release-admin/types/backoffice-user-tier";
import * as releaseAdmin from "../../sdk/release-admin";
import { rudderReset } from "../../utils/rudderstack/init";
import { ArtistNotesPage } from "../artist-notes";
import { SyncBriefsPage } from "../sync-briefs";
import { AgentViewPage } from "../agent-view";

export const AdminPage: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [tier, setTier] = React.useState<BackofficeUserTier>();

  React.useEffect(() => {
    releaseAdmin.getProfile().then((user) => setTier(user.tier));

    return () => {
      rudderReset();
    };
  }, []);

  return (
    <main style={{ width: "100%" }}>
      <AppHeader onToggleMenu={() => setIsMenuOpen(!isMenuOpen)} />

      <Container maxWidth="xl">
        <AppMenu
          isOpen={isMenuOpen}
          tier={tier}
          onClose={() => setIsMenuOpen(false)}
        ></AppMenu>
        <Switch>
          <Route exact path={routes.inbox.list}>
            <UserInboxPage />
          </Route>
          <Route exact path={routes.inbox.agentView}>
            <AgentViewPage tier={tier} />
          </Route>
          <Route exact path={routes.inbox.agentViewDetail}>
            <AgentViewPage tier={tier} />
          </Route>
          <Route exact path={routes.releases.list}>
            <ReleasesListPage />
          </Route>
          <Route path={routes.releases.detail}>
            <ReleaseDetailPage tier={tier} />
          </Route>

          <Route exact path={routes.artist.list}>
            <ArtistListPage />
          </Route>
          <Route exact path={routes.artist.detail}>
            <ArtistDetailPage />
          </Route>
          <Route exact path={routes.artist.earnings}>
            <ArtistEarningsPage />
          </Route>
          <Route exact path={routes.artist.notes}>
            <ArtistNotesPage />
          </Route>

          <Route exact path={routes.syncLicense.syncBriefs}>
            <SyncBriefsPage />
          </Route>

          <Route exact path={routes.earnings.list}>
            <EarningsListPage />
          </Route>
          <Route exact path={routes.earnings.detail}>
            <EarningsDetailPage />
          </Route>
          <Route exact path={routes.earnings.summary}>
            <EarningsSummaryPage />
          </Route>

          <Route exact path={routes.users.list}>
            <UsersListPage />
          </Route>
          <Route exact path={routes.users.detail}>
            <UserDetailPage />
          </Route>

          <Route exact path="/">
            <Redirect to={{ pathname: routes.releases.list }} />
          </Route>
        </Switch>
      </Container>
    </main>
  );
};
